"use client";

import { useEffect, useState } from "react";
import { isWindowDefined } from "@huub-web/utils";

export const useTouch = (): boolean => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    if (!isWindowDefined()) {
      return;
    }

    const checkTouchDevice = () => {
      setIsTouchDevice(
        "ontouchstart" in window || navigator.maxTouchPoints > 0,
      );
    };

    checkTouchDevice();
  }, []);

  return isTouchDevice;
};
